import { Document } from '@/features/documents/types.ts'

export function getProcessingStepText(document?: Document | null) {
  const job = document?.jobs?.[0]
  if (!document || document?.status !== 'processing' || !job) return null

  if (['started', 'pending'].includes(job.ai_analysis?.status)) {
    return 'Estrazione delle informazioni del documento...'
  }

  if (['started', 'pending'].includes(job.text_processing?.status)) {
    return 'Salvataggio del testo...'
  }

  if (['started', 'pending'].includes(job.text_extraction?.status)) {
    return 'Riconoscimento del testo...'
  }

  if (['started', 'pending'].includes(job.thumbnails_processing?.status)) {
    return 'Generazione delle thumbnail...'
  }
}

export const useGetProcessingStepDesc = (document?: Document | null) =>
  getProcessingStepText(document)
